<div class="visitor-scan-qrcode">
  <sc-flex vertical [centered]="true">
    <sc-sub-title>Halten Sie Ihren QR-Code vor die Kamera. Der Scan erfolgt automatisch.</sc-sub-title>
    <sc-content-spacer vertical [double]="true"></sc-content-spacer>
    <div class="cam">
      <zxing-scanner #scanner [enable]="scannerEnabled"
                    [device]="deviceCurrent"
                    (camerasFound)="camerasFoundHandler($event)"
                    (scanSuccess)="scanSuccessHandler($event)"
                    (scanError)="scanErrorHandler($event)"
                    (scanComplete)="scanCompleteHandler($event)"></zxing-scanner>
    </div>
    <div>
      <sc-dictionary-label [dictionaryKey]="errorMessageDictionaryKey"></sc-dictionary-label>
    </div>
  </sc-flex>
</div>
